import { TERMS_AND_CONDITIONS_VERSION } from "../../constants";

const listedClients = (group, countKey) => {
  const count = group ? group[countKey] : 0;
  if (count === 4) return [group.client2, group.client3, group.client4];
  if (count === 3) return [group.client2, group.client3];
  if (count === 2) return [group.client2];
  return [];
};

// The PUT /api/signup body for a signup flow state.
export function buildSignupSubmissionBody(flowState) {
  return {
    leadId: flowState.leadId,
    transactionType: flowState.transactionType,
    termsAndConditionsVersion: TERMS_AND_CONDITIONS_VERSION,

    sellingPropertyOfferAccepted: flowState.sellingPropertyOfferAccepted,
    sellingAddressDetails: flowState.sellingAddressDetails,
    sellingEstateAgent: flowState.sellingEstateAgent,
    sellingMortgagesAndLoans: flowState.sellingMortgagesAndLoans,

    buyingPropertyOfferAccepted: flowState.buyingPropertyOfferAccepted,
    // The purchase address step only shows once an offer is accepted, so
    // without one this holds at most the quote's price, never confirmed.
    buyingAddressDetails: flowState.buyingPropertyOfferAccepted === true ? flowState.buyingAddressDetails : undefined,
    buyingEstateAgent: flowState.buyingEstateAgent,
    buyingMortgageLender: flowState.buyingMortgageLender,
    buyingMortgageBroker: flowState.mortgageBroker,

    primaryClient: {
      ...flowState.yourName.client1,
      ...flowState.contactDetails,
    },
    otherOwners: listedClients(flowState.otherOwners, "numberOfOwners"),
    otherOwnersPurchasing: listedClients(flowState.otherOwnersPurchasing, "numberOfClientsPurchasing"),
    otherOwnersSelling: listedClients(flowState.otherOwnersSelling, "numberOfClientsSelling"),
    anythingElse: flowState.anythingElse,
  };
}
